import React, { useState } from 'react';

import { ConfirmModal } from '../../components/modals';

import { PublicEvent, Face } from '../../types';
import { goTo } from '../../utils';

import MAEmailStage from './stages/maEmailStage';
import PhotoStage from './stages/photoStage';
import VideoStage from './stages/videoStage';

interface Props {
  event: PublicEvent;
  face?: Face;
  reqAssets: string;
  refetchFace?: () => void;
}

const MissingAssetsContent: React.FC<Props> = (props) => {
  const { event, face, reqAssets, refetchFace } = props;

  const [showConfirmModal, setShowConfirmModal] = useState(false);

  const type = reqAssets?.includes('clips')
    ? 'videos'
    : reqAssets.split('-')[0];

  const renderContent = () => {
    // missing assets enter email stage
    if (!face) return <MAEmailStage event={event} reqAssets={reqAssets} />;

    // missing photo page
    if (type === 'photo')
      return (
        <PhotoStage
          event={event}
          face={face}
          handleAfterUpload={() => setShowConfirmModal(true)}
          refetchFace={refetchFace}
        />
      );

    // missing clips page
    if (type === 'videos')
      return (
        <VideoStage
          event={event}
          face={face}
          handleAfterUpload={() => setShowConfirmModal(true)}
          refetchFace={refetchFace}
          reqAssets={reqAssets}
        />
      );
  };

  return (
    <React.Fragment>
      {!!face && (
        <h5 className="w-full text-center font-normal">
          <b>Upload {reqAssets?.split('-')[0]}</b> to generate your personalised
          video at <b>{event.name}</b>
        </h5>
      )}

      {renderContent()}

      <ConfirmModal
        show={showConfirmModal}
        onHide={() => setShowConfirmModal(false)}
        heading={`Great! You have successfully uploaded your ${type} to ${event.name}.`}
        subheading={
          'Feel free to <b>close this page</b>, and keep an eye on your inbox for your personalised video.'
        }
        btns={[
          { label: 'OK', onClick: () => goTo('https://crowdclip.com/') },
          { label: 'Upload More', onClick: () => setShowConfirmModal(false) },
        ]}
      />
    </React.Fragment>
  );
};

export default MissingAssetsContent;
